module.exports = __webpack_public_path__ + "media/images/icons/select-arrows--dark-111c34ba7c7bca930c869a34f4c847d6.svg";